import { environment } from '../../../environments/environment';

/** Storefront tenant matching `businesses.key` in the API. */
export let BUSINESS_KEY = normalizeBusinessKey(environment.businessKey);

export function setBusinessKey(key: string): void {
  BUSINESS_KEY = normalizeBusinessKey(key);
}

export function getBusinessKey(): string {
  return BUSINESS_KEY;
}

/** Storefront always uses host/env key; admin uses the switcher when authenticated. */
export function resolveApiBusinessKey(
  routerUrl: string,
  authBusinessKey: string | null | undefined,
  isAuthenticated: boolean
): string {
  const storefrontKey = getBusinessKey();
  if (routerUrl.startsWith('/admin') && isAuthenticated) {
    return (authBusinessKey ?? '').trim() || storefrontKey;
  }

  return storefrontKey;
}

function normalizeBusinessKey(key: string | null | undefined): string {
  return (key ?? '').trim().toLowerCase();
}
